import React, { useCallback, useState } from 'react';
import { Loader2, X } from 'lucide-react';
import { S3Modal } from './v3/primitives';
// Le modali sono condivise con l'area rappresentante, che non passa dalla
// shell admin ne dalla pagina del Centro Ticket: i due fogli scoped (.adm2 /
// .sup3, entrambi portati da S3Modal sulla radice) vanno importati qui.
import '../../styles/admin-v2.css';
import '../../styles/support-v3.css';

/** Tetto del motivo: lo stesso del backend (`closeTicket`, 500 caratteri). */
export const CLOSE_MOTIVO_MAX = 500;

interface CloseTicketModalProps {
  busy?: boolean;
  onClose: () => void;
  onConfirm: (motivo: string) => void | Promise<void>;
}

/**
 * Conferma della chiusura diretta (Task 23/A). `ConfirmDialog` non ha campi di
 * input, e qui serve il motivo facoltativo: una piccola modale V3, sulla falsariga
 * di `TransferModal`. Il motivo resta nella sola cronologia interna.
 */
const CloseTicketModal: React.FC<CloseTicketModalProps> = ({ busy = false, onClose, onConfirm }) => {
  const [motivo, setMotivo] = useState<string>('');

  // In volo ne Escape ne il click fuori chiudono: l'esito deve arrivare a schermo.
  const requestClose = useCallback(() => {
    if (!busy) onClose();
  }, [busy, onClose]);

  return (
    <S3Modal open onClose={requestClose} labelledBy="s3-close-title">
      <div className="s3-mod">
        <div className="s3-mod__head">
          <h3 className="s3-h3" id="s3-close-title">Chiudi ticket</h3>
          <button
            type="button"
            className="s3-pill s3-pill--sm s3-pill--icon"
            onClick={onClose}
            disabled={busy}
            aria-label="Chiudi"
          >
            <X size={14} />
          </button>
        </div>

        <div className="s3-mod__body">
          <p className="s3-mod__warn">
            Il ticket viene chiuso subito, senza alcun avviso al richiedente, e non potrà essere riaperto.
          </p>
          <div className="s3-field">
            <label className="s3-label" htmlFor="s3-close-motivo">
              Motivo (solo cronologia interna)
            </label>
            <textarea
              id="s3-close-motivo"
              className="s3-ta"
              value={motivo}
              maxLength={CLOSE_MOTIVO_MAX}
              onChange={(e) => setMotivo(e.target.value)}
              rows={3}
              placeholder="Facoltativo"
            />
          </div>
        </div>

        <div className="s3-mod__foot">
          <button type="button" className="s3-pill" onClick={onClose} disabled={busy}>
            Annulla
          </button>
          <button
            type="button"
            className="s3-pill s3-pill--danger"
            onClick={() => {
              if (busy) return;
              onConfirm(motivo.trim());
            }}
            disabled={busy}
          >
            {busy && <Loader2 size={14} className="s3-spin" />}
            Chiudi ticket
          </button>
        </div>
      </div>
    </S3Modal>
  );
};

export default CloseTicketModal;
